// extracted by mini-css-extract-plugin
module.exports = {"container":"FullScreenLoader_container__1-bzW","imageScale":"FullScreenLoader_imageScale__1u_5u","scale":"FullScreenLoader_scale__lYede"};